import React, { useEffect, useState } from 'react';
import { Navigate, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { AppLayoutSkeleton } from '@/components/templates/skeletons';
import { LAYOUT } from '@/lib/constants';

interface ProtectedRouteProps {
  children?: React.ReactNode;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { user, session, loading } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  // TEMPORARILY DISABLED — mobile guard bypassed for testing
  // const [isMobile, setIsMobile] = useState(() =>
  //   window.matchMedia(`(max-width: ${LAYOUT.MOBILE_BREAKPOINT - 1}px)`).matches
  // );

  // useEffect(() => {
  //   const mq = window.matchMedia(`(max-width: ${LAYOUT.MOBILE_BREAKPOINT - 1}px)`);
  //   const handler = (e: MediaQueryListEvent) => setIsMobile(e.matches);
  //   mq.addEventListener('change', handler);
  //   return () => mq.removeEventListener('change', handler);
  // }, []);

  // useEffect(() => {
  //   if (isMobile) {
  //     navigate('/', { replace: true });
  //   }
  // }, [isMobile, navigate]);

  // if (isMobile) {
  //   return null;
  // }

  // Show loading while auth state is being determined
  if (loading) {
    return <AppLayoutSkeleton />;
  }

  // Redirect to landing page if not authenticated
  if (!user || !session) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  // No route restrictions - users can access any page they navigate to

  return children ? <>{children}</> : <Outlet />;
};